<template>
	<div v-if="value.id" class="prop-actions-wrapper">
		<!--<a :href="`/add-property/${value}`" class="btn btn-alt btn-xs btn-prop-actions">-->
			<!--<i class="fal fa-edit"></i>-->
			<!--{{ 'core.edit' | trans }}-->
		<!--</a>-->
		<!--<router-link :to="{ name: 'panel.properties.single.stats', params: { id: value.id }}" class="btn btn-alt btn-xs btn-prop-actions">-->
			<!--<i class="fal fa-chart-area"></i>-->
			<!--{{ 'core.statistic' | trans }}-->
		<!--</router-link>-->
		<!--<router-link :to="{ name: 'panel.properties.single.inbox', params: { id: value.id }}" class="btn btn-alt btn-xs btn-prop-actions">-->
			<!--<i class="fal fa-inbox-in"></i>-->
			<!--{{ 'core.inbox' | trans }}-->
		<!--</router-link>-->
		<!--<router-link :to="{ name: 'panel.properties.single.report', params: { id: value.id }}" class="btn btn-alt btn-xs btn-prop-actions">-->
			<!--<i class="fal fa-flag"></i>-->
			<!--{{ 'core.report' | trans }}-->
		<!--</router-link>-->

		<!--Delete property-->

		<!--<i class="far fa-ellipsis-h"></i>-->

			<div class="m-dropdown m-dropdown--inline m-dropdown--arrow m-dropdown--align-left m-dropdown--align-push" data-dropdown-toggle="click" aria-expanded="true"
				ref="wp"
			>
				<a href="#" @click.prevent="showList = !showList" class="table-dropdown-button btn btn-sm">
					<i class="far fa-ellipsis-h"></i>
				</a>
				<div v-show="showList" ref="list" class="m-dropdown__wrapper">
					<span class="m-dropdown__arrow m-dropdown__arrow--left m-dropdown__arrow--adjust"></span>
					<div class="m-dropdown__inner">
						<div class="m-dropdown__body">
							<div class="m-dropdown__content">
								<ul class="m-nav">

									<!--<li class="m-nav__section m-nav__section&#45;&#45;first">-->
                                        <!--<span class="m-nav__section-text">-->
                                            <!--Quick Actions-->
                                        <!--</span>-->
									<!--</li>-->

									<li class="m-nav__item" v-for="(slug,lang) in value.slug">
										<a v-for="(active,l) in value.active" v-if="lang == l && active == true"
												:href="`${lang == 'sr' ? '/sr/nekretnina' : '/property'}/${slug}`" class="m-nav__link" target="_blank"
										>
											<i class="fal fa-eye m-nav__link-icon"></i>
											<span class="m-nav__link-text">
												{{ 'core.view' | trans }} ({{lang}})
											</span>
										</a>
									</li>

									<li class="m-nav__item">
										<router-link :to="{ name: 'panel.properties.single.edit', params: { id: value.id }}" class="m-nav__link">
											<i class="fal fa-edit m-nav__link-icon"></i>
											<span class="m-nav__link-text">
												{{ 'core.edit' | trans }}
											</span>
										</router-link>
									</li>

									<li class="m-nav__item">
										<router-link :to="{ name: 'panel.properties.single.stats', params: { id: value.id }}" class="m-nav__link">
											<i class="fal fa-chart-area m-nav__link-icon"></i>
											<span class="m-nav__link-text">
												{{ 'core.statistic' | trans }}
											</span>
										</router-link>
									</li>


									<li class="m-nav__item">
										<router-link :to="{ name: 'panel.properties.single.inbox', params: { id: value.id }}" class="m-nav__link">
											<i class="fal fa-inbox-in m-nav__link-icon"></i>
											<span class="m-nav__link-text">
												{{ 'core.inbox' | trans }}
											</span>
										</router-link>
									</li>

									<li class="m-nav__item">
										<router-link :to="{ name: 'panel.properties.single.report', params: { id: value.id }}" class="m-nav__link">
											<i class="fal fa-flag m-nav__link-icon"></i>
											<span class="m-nav__link-text">
												{{ 'core.report' | trans }}
											</span>
										</router-link>
									</li>
									<!--<li class="m-nav__item" @click.stop>-->
										<!--<a class="m-nav__link">-->
											<!--<i class="fal fa-trash m-nav__link-icon"></i>-->
											<!--<span class="m-nav__link-text">-->
												<!--<confirm-popover @confirm="removeProperty(value)">-->
													<!--{{ 'core.remove' | trans }}-->
												<!--</confirm-popover>-->
											<!--</span>-->
										<!--</a>-->
									<!--</li>-->
									<li class="m-nav__separator m-nav__separator--fit"></li>
									<li class="m-nav__item" @click.stop>
										<confirm-popover @confirm="removeProperty" v-if="value.id">
											<a class="m-nav__link">
												<i class="fal fa-trash m-nav__link-icon"></i>
												<span class="m-nav__link-text">
														{{ 'core.remove' | trans }}
												</span>
											</a>
										</confirm-popover>
									</li>
									<!--<li class="m-nav__separator m-nav__separator&#45;&#45;fit"></li>-->
									<!--<li class="m-nav__item">-->
										<!--<a href="#" class="btn btn-outline-danger m-btn m-btn&#45;&#45;pill m-btn&#45;&#45;wide btn-sm">-->
											<!--{{ 'frontend.cancel' | trans }}-->
										<!--</a>-->
									<!--</li>-->
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
	</div>
</template>
<style lang="less">
	.table-dropdown-button {
		background: #fff;
		border-color: #ebedf2;
		border-radius: 60px;
		font-size: 20px;
		&:hover {
			border-color: #ebedf2;
			background-color: #e0e0e0;
		}
		i {
			font-size: 2.1rem;
			color: #6f727d;
			vertical-align: middle;
		}
	}
	.prop-actions-wrapper {
		width: 130px;
		margin-left: -10px;
		margin-top: -10px;
		padding-top: 25px;
		background: white;
		text-align: center;
		position: absolute;
		top: 0;
		bottom: 0;
		.m-nav__link-text{
			padding: 10px 5px 10px 0px !important;
		}
		.m-nav__link .confirm-group button.btn.btn-danger{
			background: none;
			color: #6f727d;
			border: none;
			padding: 0 !important;
		}
		.popover.confirmation{
			padding: 20px;
			width: 300px;
			.popover-title{
				color: #444;
				font-family: 'Gilroy Extra Bold';
				text-align: center;
				margin-bottom:40px;
			}
			.popover-content{
				color:white;
				.btn{
					width: 50px;
					font-weight: bold;
				}
			}
		}
	}
</style>
<script>
import toastr from 'mini-toastr';
import axios from 'axios';
export default {
    props: ['value'],
    data() {
        return {
            showList: false
        };
    },
    mounted() {
        toastr.init();
    },
    methods: {
        removeProperty() {
            axios.post(`/api/remove/${this.value.id}`)
                .then(() => {
                    this.$emit('remove');
                    this.$refs.wp.click();
                    toastr.error('Property removed');
                });
        },
        documentClick(e) {
            let target = e.target;
            let el = this.$el;
            if (!el.contains(target) || !this.$refs.list.contains(target)) {
                this.showList = false;
            }
        }
    },
    created() {
        document.addEventListener('click', this.documentClick, true);
        document.addEventListener('touchstart', this.documentClick, true);
    },
    destroyed() {
        document.removeEventListener('click', this.documentClick, true);
        document.removeEventListener('touchstart', this.documentClick, true);
    }
};
</script>


// WEBPACK FOOTER //
// resources/js/metronic/table/value/panel/PropertyActions.vue